import { Trans } from "react-i18next"
import { MdOutlineInventory2 } from "react-icons/md"
import { NotFound } from "./styled"

interface INotFoundMedia { 
    mode?: 'scorm' | 'media'
}

export const NotFoundMedia: React.FC<INotFoundMedia> = ({ mode = "media" }) => {
    const variant = {
        media: "notFound.fileView",
        scorm: "notFound.scormView",
     }
    return (
        <NotFound>
            <MdOutlineInventory2 className="mb-3" fontSize={40} />
            <div><Trans>{variant[mode]}</Trans></div>
        </NotFound>
    )
}